import { alpha, makeStyles } from '@material-ui/core'

const styles = ({
  attachmentsBgcolor,
  backgroundColor,
  color,
  isDragActive,
  highlight,
  width,
  disabled,
  error,
  hasDownloadFile,
}) =>
  makeStyles((theme) => ({
    formControl: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      cursor: disabled ? 'not-allowed' : 'pointer',
      minHeight: 150,
      gap: theme.spacing(1),
      padding: theme.spacing(2),
      border: `2px dashed ${color}`,
      borderRadius: 4,
      color: color,
      backgroundColor: backgroundColor,
      width: width,
      ...(highlight &&
        !disabled && {
          '&:hover': { backgroundColor: alpha(color, 0.12) },
          ...(isDragActive && { backgroundColor: alpha(color, 0.12) }),
        }),
    },
    title: {
      fontWeight: isDragActive ? 500 : 400,
    },
    input: {
      display: 'none',
    },
    controlBar: {
      paddingInline: theme.spacing(2),
      paddingTop: theme.spacing(2),
      border: `1px solid ${theme.palette.textfield.border}`,
      borderRadius: 4,
      color: theme.palette.custom.dark,
      marginTop: theme.spacing(2),
      backgroundColor: backgroundColor,
    },
    attachmentItem: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
      borderRadius: 4,
      backgroundColor: attachmentsBgcolor,
      cursor: hasDownloadFile ? 'pointer' : 'default',
      width: 'fit-content',
      maxWidth: '100%',
    },
    // Nome de arquivo sem espaço não quebra sozinho: o item crescia além da barra e virava scroll
    // horizontal. Limitado à largura da barra, o nome quebra em quantas linhas precisar.
    attachmentInfo: {
      minWidth: 0,
    },
    attachmentIcon: {
      flexShrink: 0,
    },
    attachmentName: {
      minWidth: 0,
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
    previewButton: {
      ...(error && {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        '&:hover': {
          borderColor: theme.palette.error.dark,
        },
      }),
    },
  }))

export default styles
